module.exports = __webpack_public_path__ + "338dc31f7027fd0dff68007aeb81e384.png";